/**
 * "Safer" String.toUpperCase()
 */
var toUpperCase = function toUpperCase(str) {
  return str.toUpperCase();
};

export default toUpperCase;